import React, { useState, useEffect } from 'react';
import { Player } from '../types/GameTypes';
import socketService from '../services/socketService';
import { MessageType } from '../services/WebSocketMessageHandler';
import './Lobby.css';

const vikingHeroes = [
  'viking-1',
  'viking-2',
  'viking-3',
  'viking-4',
  'viking-5',
  'viking-6',
];

interface LobbyProps {
  initialPlayers: Player[];
  gameId: string | null;
}

const Lobby: React.FC<LobbyProps> = ({ initialPlayers, gameId }) => {
  const [players, setPlayers] = useState<Player[]>(initialPlayers);
  const [selectedHeroIndex, setSelectedHeroIndex] = useState(0);

  useEffect(() => {
    const handlePlayerList = (message: { type: string; players?: Player[] }) => {
      if (message.players) {
        setPlayers(message.players);
      }
    };

    // Register message handler for player list updates
    socketService.addMessageHandler(MessageType.GAME_STATE_UPDATE, handlePlayerList);

    return () => {
      socketService.removeMessageHandler(MessageType.GAME_STATE_UPDATE, handlePlayerList);
    };
  }, []);

  const handleHeroSelection = (newIndex: number) => {
    const hero = vikingHeroes[newIndex];
    setSelectedHeroIndex(newIndex);
    socketService.sendMessage({ type: MessageType.SELECT_HERO, hero, gameId });
  };

  const handleNextHero = () => {
    const newIndex = (selectedHeroIndex + 1) % vikingHeroes.length;
    handleHeroSelection(newIndex);
  };

  const handlePrevHero = () => {
    const newIndex = (selectedHeroIndex - 1 + vikingHeroes.length) % vikingHeroes.length;
    handleHeroSelection(newIndex);
  };

  const handleReady = () => {
    socketService.sendMessage({ type: MessageType.TOGGLE_READY, gameId });
  };

  return (
    <div className="lobby-container">
      <h2>Game Lobby</h2>
      <div className="hero-selection">
        <h3>Select Your Hero</h3>
        <div className="hero-selector">
          <button onClick={handlePrevHero}>&lt;</button>
          <img
            src={`/assets/${vikingHeroes[selectedHeroIndex]}.svg`}
            alt={vikingHeroes[selectedHeroIndex]}
            className="hero-preview"
          />
          <button onClick={handleNextHero}>&gt;</button>
        </div>
      </div>
      <button onClick={handleReady} className="ready-button">
        Ready Up!
      </button>
      <div className="player-list">
        {players.map((player) => (
          <div key={player.id} className="player-card">
            <img
              src={`/assets/${player.hero}.svg`}
              alt={player.hero}
              className="player-hero-avatar"
            />
            <div className="player-name">{player.name}</div>
            <div className={`player-status ${player.isReady ? 'ready' : 'not-ready'}`}>
              {player.isReady ? 'Ready' : 'Not Ready'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Lobby;
